<div class="page">
  <div class="title">
    <button class="buttonBack" *ngIf="step !== 5" (click)="goBack()">←</button>
    <div class="titleValue">{{ "issue.new" | transloco }}</div>
  </div>
  <div class="sections">
    <div class="titleSection">
      {{
        step === 1
          ? this.productoSelected
            ? ("issue.productFound" | transloco)
            : ("issue.findProduct" | transloco)
          : step === 2
          ? ("issue.selectProblem" | transloco)
          : step === 3
          ? selectedSintoma
            ? ("issue.solutionGuide" | transloco)
            : ("issue.selectPart" | transloco)
          : step === 4
          ? ("issue.addObservations" | transloco)
          : ("issue.successCreate" | transloco)
      }}
    </div>
    <div *ngIf="step === 1 && !productoSelected" class="productoForm">
      <form [formGroup]="formProducto" style="width: 100%">
        <div class="inputProductoGroup">
          <mat-label class="labelProducto"
            >{{ "issue.enterSerial" | transloco }} (XX.XX.XXXXXX.XX)</mat-label
          >
          <div class="mascara">
            <input
              class="inputProductoMascaraCorto"
              matInput
              name="numSerie1"
              type="text"
              pattern="\d*"
              #numSerie1Input
              formControlName="numserie1"
              maxlength="2"
            />
            .
            <input
              class="inputProductoMascaraCorto"
              matInput
              name="numSerie2"
              type="text"
              pattern="\d*"
              #numSerie2Input
              formControlName="numserie2"
              maxlength="2"
            />
            .
            <input
              class="inputProductoMascaraLargo"
              matInput
              name="numSerie3"
              type="text"
              pattern="\d*"
              #numSerie3Input
              formControlName="numserie3"
              maxlength="6"
            />
            .
            <input
              class="inputProductoMascaraCorto"
              matInput
              name="numSerie4"
              type="text"
              pattern="\d*"
              #numSerie4Input
              formControlName="numserie4"
              maxlength="2"
            />
          </div>
        </div>

        <mat-label class="labelProducto" style="margin-top: 20px">{{
          "issue.purchaseTicket" | transloco
        }}</mat-label>
        <div class="photoSpace" style="position: relative">
          <button *ngIf="!reciboCompraImage" class="buttonPhoto">
            <img
              style="width: 40px; height: 40px"
              src="../../../assets/bergara/photo_icon.svg"
              (click)="openPhotoCaptureDialog()"
            />
          </button>
          <button
            *ngIf="reciboCompraImage"
            class="buttonPhotoClose"
            (click)="resetReciboImage()"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <img
            *ngIf="reciboCompraImage"
            [src]="reciboCompraImage"
            style="height: auto; width: 100%"
          />
        </div>
      </form>

      <button
        *ngIf="!productoSelected"
        class="buttonStyle"
        style="margin-top: 20px"
        (click)="comprobarActivo()"
      >
        {{ "issue.check" | transloco }}
      </button>
    </div>

    <div *ngIf="step === 1 && productoSelected" class="productoForm">
      <div class="titleSection" style="font-size: 16px">
        {{ "issue.continue" | transloco }}
      </div>
      <div class="productoCardDetalle" style="margin-top: 20px">
        <div class="imgName">
          <img
            [src]="
              getUrlImageArticulo(
                productoSelected ? productoSelected.imagenes[0]?.ID : null
              )
            "
            alt="Imagen del artículo"
            width="200px"
          />
          <div style="margin-bottom: 20px">
            {{
              productoSelected?.marca_dispositivo?.name +
                " " +
                productoSelected?.modelo_dispositivo?.name
            }}
          </div>
        </div>
      </div>
      <button
        class="buttonStyle"
        style="margin-top: 20px"
        (click)="siguientePaso()"
      >
        {{ "general.next" | transloco }}
      </button>
    </div>

    <div *ngIf="step === 2">
      <div class="completedSintomasList">
        <div
          style="display: flex; width: 100%"
          *ngFor="let sintoma of symptonCodes"
        >
          <div
            [class]="
              selectedSintoma === sintoma
                ? 'sintomaCardSelected'
                : 'sintomaCard'
            "
            (click)="codesSelection(sintoma, 'sintoma')"
          >
            <div>
              {{
                activeLang === "en"
                  ? sintoma.English_EN
                  : activeLang === "fr"
                  ? sintoma.Fran_ais_FR
                  : sintoma.descripcion
              }}
            </div>
          </div>
        </div>
        <div class="sintomaCard2" (click)="codesSelection(null, 'sintoma')">
          {{ "issue.otherProblemOption" | transloco }}
        </div>
      </div>
    </div>

    <div *ngIf="step === 3">
      <div class="opcionesList" *ngIf="selectedSintoma">
        <div *ngFor="let sintoma of pasosCategory">
          <div class="optionCard">
            <div style="font-weight: 600">
              {{ "issue.option" | transloco }} {{ sintoma.opcion }}
            </div>
            <div class="pasosList" *ngFor="let paso of sintoma.pasos">
              <div class="pasoLine">
                ·
                {{
                  activeLang === "en"
                    ? paso.English_EN
                    : activeLang === "fr"
                    ? paso.Fran_ais_FR
                    : paso.value
                }}
              </div>
              <div class="imagenesPaso" *ngFor="let imagen of paso.imagenes">
                <img
                  class="imagenPaso"
                  *ngIf="imagen.base64"
                  [src]="imagen.base64"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-top: 40px;
            "
          >
            <button
              class="buttonStyle"
              style="width: 340px"
              (click)="openMunicionRecomendada()"
            >
              {{ "issue.recommendedAmmo" | transloco }}
            </button>
          </div>
          <div
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-top: 40px;
            "
          >
            <button
              class="buttonStyle"
              style="width: 340px"
              (click)="problemaNoSolucionado()"
            >
              {{ "issue.notSolvedProblem" | transloco }}
            </button>
          </div>
          <div
            *ngIf="pasosCategory.length > 0"
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-top: 40px;
            "
          >
            <button
              class="buttonStyle"
              style="width: 300px; background-color: #f6c527"
              (click)="crearTicket('old_done')"
            >
              {{ "issue.solvedProblem" | transloco }}
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="!selectedSintoma">
        <div class="completedSintomasList">
          <div
            style="display: flex; width: 100%"
            *ngFor="let section of sectionCodes"
          >
            <div
              [class]="
                selectedSection === section
                  ? 'sintomaCardSelected'
                  : 'sintomaCard'
              "
              (click)="codesSelection(section, 'seccion')"
            >
              <div>
                {{
                  activeLang === "en"
                    ? section.English_EN
                    : activeLang === "fr"
                    ? section.Fran_ais_FR
                    : section.descripcion
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="step === 4">
      <form [formGroup]="formProducto" style="width: 100%">
        <div>
          <div class="labelMotivo" style="margin-top: 20px">
            {{ "issue.observations" | transloco }}
          </div>
          <div class="divTextareaMotivo">
            <textarea
              class="textareaMotivo"
              name="motivo"
              formControlName="motivo"
            ></textarea>
          </div>
        </div>
        <div class="adjuntosForm">
          <div
            class="labelMotivo"
            style="margin-top: 20px; margin-bottom: 20px"
          >
            {{ "issue.attachments" | transloco }}
          </div>
          <div class="adjuntosBox">
            <div class="adjuntosGroup" *ngIf="adjuntos.length > 0">
              <div class="adjuntoCard" *ngFor="let adjunto of adjuntos">
                <div style="display: flex; justify-content: space-between">
                  <div class="labelMotivo" style="margin-bottom: 10px">
                    {{ adjunto.name }}
                  </div>
                  <div (click)="deleteItemListMultimedia(adjunto)">
                    <mat-icon>delete</mat-icon>
                  </div>
                </div>
                <div
                  style="border-radius: 8px"
                  *ngIf="adjunto.type === 'photo'"
                  style="
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: 100%;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img
                    [src]="adjunto.base64"
                    style="border-radius: 8px"
                    width="100%"
                    height="100%"
                  />
                </div>
                <video
                  style="border-radius: 8px"
                  #previewVideo
                  width="100%"
                  height="100%"
                  [src]="adjunto.base64"
                  *ngIf="adjunto.type === 'video'"
                  controls
                ></video>
              </div>
            </div>
            <div class="buttonAddAdjunto" (click)="openPhotoCaptureDialog()">
              +
            </div>
          </div>
        </div>
      </form>
      <div
        style="
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 40px;
        "
      >
        <button
          class="buttonStyle"
          style="width: 340px"
          (click)="crearTicket('new')"
        >
          {{ "issue.createIssue" | transloco }}
        </button>
      </div>
    </div>

    <div *ngIf="step === 5">
      <div>{{ "issues.issueNumber" | transloco }}: {{ newTicket.ID }}</div>
      <div>{{ "issue.issueConfirmation" | transloco }}</div>
      <div
        style="
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 40px;
        "
      >
        <button
          class="buttonStyle"
          style="width: 200px"
          (click)="navigateCasos()"
        >
          {{ "issue.goToIssues" | transloco }}
        </button>
      </div>
    </div>
  </div>
  <div class="loaderBox" *ngIf="loadingCrearTicket">
    <span class="loader"></span>
  </div>
</div>
